<template>
  <div class="productcontainer">
    <div class="pagetitle"><H3 class="title">产品详情</H3></div>
    <div class="product-title">{{ products[showwitch].name }}</div>
    <div v-for="(p, id) of products[showwitch].images" :key="id">
      <img class="productshow-image" :src="p.path" />
    </div>
    <div class="product-description">{{ products[showwitch].descript }}</div>
  </div>
</template>

<script>
export default {
  name: "ShowProduct",
  created() {
    this.showwitch = this.$route.params.id - 1;
  },
  data() {
    return {
      showwitch: 0,
      products: [
        {
          id: 1,
          name: "博邦方舟 无创血糖仪",
          images: [
            {
              id: 1,
              title: true,
              path: require("@/assets/productimages/01-01.jpg"),
            },
            {
              id: 2,
              title: false,
              path: require("@/assets/productimages/01-02.jpg"),
            },
          ],
          descript: `
                  【产品】：博邦方舟 无创血糖仪
                  【型号】：NIGA03
                  【显示屏】：1.77英寸
                  【电源】：充电状态下额定AC220V/50Hz,非充电状态下内部电池DC3.7v.
                  【探头尺寸】：70.5mm*40.8*39.5mm
                  【净重】：70g
              `,
        },
        {
          id: 2,
          name: "葡清®天然皂液",
          images: [
            {
              id: 1,
              title: true,
              path: require("@/assets/productimages/02-01.jpg"),
            },
            {
              id: 2,
              title: false,
              path: require("@/assets/productimages/02-02.jpg"),
            },
          ],
          descript: `
              
                  【产品】：葡清®天然皂液
                  【主要成份】：纯天然植物皂化物等。本品采用纯天然活性物质为原料，采用高科技无磷配方，性能特点：含有天然护肤因子，具有泡沫细腻、强效去污、高效除菌和易冲洗、无残留等特点。
                  【产品规格】：500ml/瓶
                  【有效期】：24个月
                  【使用范围】：适用于日常皮肤的清洁、去污及外科手术第一遍洗手。
                  【使用方法】：先用少量水清洗双手，然后取本品适量于手心，按利尔康七步洗手法充分搓擦，然后用清水冲洗干净。             
              `,
        },
        {
          id: 3,
          name: "利尔康泡腾消毒片",
          images: [
            {
              id: 1,
              title: true,
              path: require("@/assets/productimages/03-01.jpg"),
            },
          ],
          descript: `【产品】：葡清®天然皂液
                  【主要成份】：纯天然植物皂化物等。本品采用纯天然活性物质为原料，采用高科技无磷配方，性能特点：含有天然护肤因子，具有泡沫细腻、强效去污、高效除菌和易冲洗、无残留等特点。
                  【产品规格】：500ml/瓶
                  【有效期】：24个月
                  【使用范围】：适用于日常皮肤的清洁、去污及外科手术第一遍洗手。
                  【使用方法】：先用少量水清洗双手，然后取本品适量于手心，按利尔康七步洗手法充分搓擦，然后用清水冲洗干净。             
              `,
        },
      ],
    };
  },
};
</script>


<style scoped>
.product-description {
  padding: 15px;
  color: white;
  background-color: #0c4a3e;
  text-align: left;
  white-space:pre-line;
}
.product-title {
  padding: 8px;
  text-align: left;
  font-size: 19px;
}
.productshow-image {
  max-width: 600px;
}
</style>